// EnquiryModal.js
import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import { apiRequest } from '../services/api';
import { toast } from 'react-toastify';

// Required for accessibility
Modal.setAppElement('#root');

const EnquiryModal = ({ isOpen, onRequestClose }) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
        mobile: ''
    });

    useEffect(() => {
        if (isOpen) {
            setFormData({
                name: '',
                email: '',
                subject: '',
                message: '',
                mobile: ''
            });
            setErrors({});
        }
    }, [isOpen]);

    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.id]: e.target.value });
        setErrors({ ...errors, [e.target.id]: '' });
    };

    const validate = () => {
        let newErrors = {};
        if (!formData.name.trim()) newErrors.name = 'Name is required';
        if (!formData.email.trim()) {
            newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
            newErrors.email = 'Email is invalid';
        }
        const mobileRegex = /^\+?[0-9]{8,15}$/;
        if (!formData.mobile.trim()) {
            newErrors.mobile = 'Mobile number is required';
        } else if (!mobileRegex.test(formData.mobile.trim())) {
            newErrors.mobile = 'Enter a valid mobile number (with or without country code)';
        }
        if (!formData.subject.trim()) newErrors.subject = 'Subject is required';
        if (!formData.message.trim()) newErrors.message = 'Message is required';

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validate()) {
            try {
                 setLoading(true);
                const res = await apiRequest({
                    url: '/enquiry',
                    method: 'POST',
                    data: formData
                });

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'form_submit',
                    form_type: 'Enquiry',
                    form_location: window.location.pathname,
                });

                toast.success('Enquiry sent successfully!');
                setFormData({ name: '', email: '', subject: '', message: '',mobile: '' });
                onRequestClose();
            } catch (err) {
                console.error('Error sending mail:', err.message);
                // Optionally show error to user
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            contentLabel="Enquiry Modal"
            className="Modal bg-light mx-3"
            overlayClassName="Overlay"
        >
            <div className="modal-header">
                <h5 className="modal-title">Enquiry</h5>
                <button type="button" className="btn-close" onClick={onRequestClose}></button>
            </div>
            <div className="modal-body">
                <div className='row'>
                    <div className='col-12'>
                        <form>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="text" onChange={handleChange} className={`form-control border-0 ${errors.name ? 'is-invalid' : ''}`} id="name" placeholder="Your Name" />
                                        <label htmlFor="name">Your Name</label>
                                        {errors.name && <div className="text-danger small ms-1 mt-1">{errors.name}</div>}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-floating">
                                        <input type="text" onChange={handleChange} className={`form-control border-0 ${errors.mobile ? 'is-invalid' : ''}`} id="mobile" placeholder="Your Mobile Number" />
                                        <label htmlFor="mobile">Your Mobile Number</label>
                                        {errors.mobile && <div className="text-danger small ms-1 mt-1">{errors.mobile}</div>}
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-floating">
                                        <input type="email" onChange={handleChange} className={`form-control border-0 ${errors.email ? 'is-invalid' : ''}`} id="email" placeholder="Your Email" />
                                        <label htmlFor="email">Your Email</label>
                                        {errors.email && <div className="text-danger small ms-1 mt-1">{errors.email}</div>}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <input type="text" onChange={handleChange} className={`form-control border-0 ${errors.subject ? 'is-invalid' : ''}`} id="subject" placeholder="Subject" />
                                        <label htmlFor="subject">Subject</label>
                                        {errors.subject && <div className="text-danger small ms-1 mt-1">{errors.subject}</div>}
                                    </div>
                                </div>
                                <div className="col-12">
                                    <div className="form-floating">
                                        <textarea
                                            className={`form-control border-0 ${errors.message ? 'is-invalid' : ''}`}
                                            placeholder="Leave a message here"
                                            id="message"
                                            onChange={handleChange}
                                            style={{ height: '160px' }}
                                        ></textarea>
                                        <label htmlFor="message">Message</label>
                                        {errors.message && <div className="text-danger small">{errors.message}</div>}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button className="btn btn-secondary" onClick={onRequestClose}>Close</button>
                <button className="btn btn-primary" disabled={loading} onClick={handleSubmit}>
                    {loading ? (
                        <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Please wait...
                        </>
                    ) : (
                        'Send'
                    )}
                </button>
            </div>
        </Modal>
    );
};

export default EnquiryModal;
